import styled, { css } from 'styled-components';
import { halfStep, step, zIndex } from 'tokens';

interface ContentProps {
	$isMobile?: boolean;
}
export const BaseContent = css<ContentProps>`
	position: relative;
	z-index: ${zIndex.contextMenu};
	background: ${({ theme }) => theme.gray[200]};
	border-radius: ${({ $isMobile }) => ($isMobile ? '8px' : '3px')};
	border: 1px solid #00000022;
	overflow: hidden;
	box-shadow: ${({ $isMobile }) =>
		$isMobile ? '0 8px 24px rgba(0, 0, 0, 0.25)' : '0 6px 12px rgba(0, 0, 0, 0.15)'};
	min-width: ${({ $isMobile }) => ($isMobile ? '200px' : 'auto')};
	max-width: ${({ $isMobile }) => ($isMobile ? '90vw' : 'auto')};
`;

interface ItemProps {
	disabled?: boolean;
	$isMobile?: boolean;
}
export const BaseItem = css<ItemProps>`
	display: flex;
	justify-content: space-between;
	white-space: nowrap;
	user-select: none;
	padding: ${({ $isMobile }) =>
		$isMobile ? `${step * 1}px ${step * 2.5}px` : `${halfStep}px ${step}px`};
	outline: none;
	min-height: ${({ $isMobile }) => ($isMobile ? '44px' : 'auto')};
	align-items: center;

	font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '11px')};
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ disabled, theme }) => (disabled ? theme.gray[600] : theme.gray[1000])};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};

	/* Remove default mobile tap highlight */
	-webkit-tap-highlight-color: transparent;

	&[data-highlighted] {
		background: ${({ theme, disabled }) => (disabled ? theme.gray[200] : theme.blue[500])};
		outline: none;
	}

	/* Touch feedback for mobile */
	&:active {
		background: ${({ theme, disabled, $isMobile }) =>
			$isMobile ? (disabled ? theme.gray[200] : theme.blue[600]) : 'transparent'};
		transform: ${({ $isMobile, disabled }) => ($isMobile && !disabled ? 'scale(0.98)' : 'none')};
		transition: all 0.1s ease;
	}
`;

interface ShortcutProps {
	$isMobile?: boolean;
}
export const MenuShortcut = styled.div<ShortcutProps>`
	/* hide keyboard shortcuts on mobile */
	display: ${({ $isMobile }) => ($isMobile ? 'none' : 'block')};
	padding-left: 10px;
	font-size: 11px;
	opacity: 0.7;
`;

export const Checkmark = styled.div<{ $isMobile?: boolean }>`
	padding-left: 10px;
	font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '11px')};
	opacity: 0.7;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const MenuSeparator = css`
	height: 1px;
	border-bottom: 0.5px solid ${({ theme }) => theme.gray[400]};
	margin-top: 2px;
	margin-bottom: 1px;
`;

export const MenuTrigger = css`
	all: unset;
`;

export const MenuPortal = css``;
